<template>
  <el-container>
    <!-- 头部 -->
      <el-header>
        <div>
          <!--<img src="../assets/logo.png" alt />-->
          <span >后台管理系统</span>
          <div v-if="_show_agent==1" class="row flex-center" style="margin-left: 1.5rem;">服务商：
            <img v-show="hinfo.serv_agent_hinfo.icon_url && hinfo.serv_agent_hinfo.icon_url.length>0" :src="hinfo.serv_agent_hinfo.icon_url" />
            {{hinfo.serv_agent_hinfo.name}}
          </div>
        </div>
        <div >
          <div style="margin-right: 9px">
            <!--<img src="../assets/logo.png" alt />-->
            <span>{{phone}}</span>
            <span v-if="_name">{{_name}}</span>
            <span v-for="item in iden" :key="item">{{item}}</span>
          </div>
          <el-button type="info" @click="logout">退出</el-button>
        </div>
      </el-header>
      <!-- 主体 -->
      <el-container>
        <!-- 侧边栏 -->
        <el-aside :width="isCollapse ? '64px' : '200px'">
          <div class="toggle-button" @click="togleCollapse">|||</div>
          <el-menu  :collapse="isCollapse" :collapse-transition="false" router :default-active="activePath" background-color="#333744" text-color="#fff" active-text-color="#409FFF">
            <el-submenu  :index="item.id" v-for="item in menuList" :key="item.id" v-if="item.isshow">
              <!-- 一级菜单的模板区域 -->
              <template slot="title">
                <i :class="iconObj[item.id]"></i>
                <span>{{ item.authName}}</span>
              </template>
              <!-- 二级菜单 -->
              <el-menu-item :index="'/' + subItem.path" v-for="subItem in item.children" :key="subItem.id" @click="saveNavState('/' + subItem.path)" v-if="subItem.isshow">
                <!-- 导航开启路由模式：
                  将index值作为导航路由 -->
                <!-- 二级菜单的模板区域 -->
                <template slot="title">
                  <i class="el-icon-menu"></i>
                  <span>{{ subItem.authName}}</span>
                </template>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </el-aside>
        <!-- 内容主体 -->
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
  </el-container>
</template>

<script>
export default {
  data () {
    return {
      // 左侧菜单数据
      menuList: [
        {
          "id": 1,
          "authName": "账户",
          "path": null,
            "isshow":true,
          "children": [
            {
              "id": 100,
              "authName": "我的账户列表",
              "path": 'lists',
              "children": [],
                "isshow":true,
            },
              {
                  "id": 210,
                  "authName": "全部账户列表",
                  "path": 'alllists',
                  "children": [],
                  "isshow":false,

              }
          ]
        },{
              "id": 4,
              "authName": "员工",
              "path": null,
              "isshow":true,
              "children": [
                  {
                      "id": 400,
                      "authName": "员工列表",
                      "path": 'staff-list',
                      "children": [],
                      "isshow":true,
                  }, {
                      "id": 401,
                      "authName": "全部员工列表",
                      "path": 'all-staff-list',
                      "children": [],
                      "isshow":false,
                  },
                   {
                      "id": 403,
                      "authName": "员工分组",
                      "path": 'staff-department',
                      "children": [],
                      "isshow":true,
                  },
              ]
          },
          {
              "id": 2,
              "authName": "用户",
              "path": null,
              "isshow":true,
              "children": [
                  {
                      "id": 200,
                      "authName": "用户列表",
                      "path": 'userquery',
                      "children": [],
                      "isshow":false,
                  },
                  {
                      "id": 201,
                      "authName": "用户详情和编辑",
                      "path": 'user-edit',
                      "children": [],
                      "isshow":true,
                  },
                  {
                      "id": 202,
                      "authName": "修改密码",
                      "path": 'psd-edit',
                      "children": [],
                      "isshow":true,
                  }
              ]
          }, {
              "id": 3,
              "authName": "总部",
              "path": null,
              "isshow":false,
              "children": [
                  {
                      "id": 300,
                      "authName": "总部列表",
                      "path": 'head-list',
                      "children": [],
                      "isshow":false,
                  },
              ]
          },
          {
              "id": 5,
              "authName": "任务",
              "path": null,
              "isshow":false,
              "children": [
                  {
                      "id": 500,
                      "authName": "任务列表",
                      "path": 'task-list',
                      "children": [],
                      "isshow":false,
                  },
                  {
                      "id": 501,
                      "authName": "相关任务列表",
                      "path": 're-task-list',
                      "children": [],
                      "isshow":true,
                  },
              ]
          },
      ],
      iconObj: {
        '125': 'iconfont icon-user',
        '103': 'iconfont icon-tijikongjian',
        '101': 'iconfont icon-shangpin',
        '102': 'iconfont icon-danju',
        '145': 'iconfont icon-baobiao'
      },
      // 默认不折叠
      isCollapse: false,
      // 被激活导航地址
      activePath: '',
      phone:"",
      iden:[],
      _name:"",
      _show_agent:0,
      hinfo:{name:"",id:0,serv_agent_hinfo: {
          ali_logon_id: "",
          ali_name: "",
          alipay_user_id: "",
          cate: "serv_agent",
          create_time: 1620462195,
          hr_account_id: 0,
          icon_url: "https://mdn.alipayobjects.com/mif_pub/afts/file/A*ebTKQ5F1ZjQAAAAAAAAAAAAAG5B2AQ",
          id: 0,
          name: "",
          pit_rate: 0,
          serv_agent_head_id: 1,
          serv_rate: 100,
          status: 0,
          update_time: 1620742075,
          vat_rate: 0
      }}
    }
  },
  created () {

    var hinfo = (sessionStorage.getItem("hinfo"));
    if(hinfo){
      this.hinfo=JSON.parse(hinfo);
    }

    this._name=sessionStorage.getItem("_name");
    this._show_agent= sessionStorage.getItem("_show_agent");


    var sign  = JSON.parse(window.sessionStorage.getItem('sign'));
    console.log(sign);
    sign.forEach(e => {
      console.log(e)
         if(e=="admin"){
        this.iden.push("管理员")
          for (let i of this.menuList){
              i["isshow"]=true;
              for(let j of i.children){
                  j["isshow"]=true;
              }
          }
      }else if(e=="hr"){
        this.iden.push("hr")
        for (let i of this.menuList){
              if(i.id===5){
                i["isshow"]=true;
                for(let j of i.children){
                    j["isshow"]=true;
                }
                break;
              }
          }
      }else if(e=="flex_staff"){
        this.iden.push("灵活用工")
        for (let i of this.menuList){
              if(i.id==5){
                i["isshow"]=true;
                break;
              }
          }
      }
    });

      this.phone=window.sessionStorage.getItem('phone');
    this.activePath = window.sessionStorage.getItem('activePath')
  },
  methods: {
    logout () {
      // 清空token
      window.sessionStorage.clear()
      this.$router.push('/login')
    },

    // 菜单的折叠与展开
    togleCollapse () {
      this.isCollapse = !this.isCollapse
    },
    // 保存连接的激活地址
    saveNavState (activePath) {
      window.sessionStorage.setItem('activePath', activePath)
    },

  }
}
</script>

<style lang="less" scoped>
.el-container {
  height: 100%;
}
.el-header {
  background-color: #373f41;
  display: flex;
  justify-content: space-between;
  padding-right: 20px;
  align-items: center;
  color: #fff;
  font-size: 20px;
  > div {
    display: flex;
    align-items: center;
    img {
      height: 40px;
    }
    span {
      margin-left: 15px;
    }
  }
}
.el-aside {
  background-color: #333744;

  .el-menu {
    border: none;
  }
}
.el-main {
  background-color: #eaedf1;
}
.iconfont{
  margin-right: 10px;
}
.toggle-button {
  background-color: #4A5064;
  font-size: 10px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.2em;
  // 鼠标放上去变成小手
  cursor: pointer;
}

</style>
